import { paletteHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { WebLink } from '../../../app-kit/components/WebLink/types';
import { BreadCrumbsBar } from '../../../app-kit/components/BreadCrumbs/BreadCrumbs';
import { useSearchLandingPageBySlugQuery } from '../../graphql/useSearchLandingPageBySlugQuery';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';

interface SearchLandingPageBreadCrumbsProps {
  crumbs: WebLink[];
}

const SearchLandingPageBreadCrumbsContainer = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
`;

const SearchLandingPageBreadCrumbs: FunctionComponent<SearchLandingPageBreadCrumbsProps> = ({
  crumbs,
}: {
  crumbs: WebLink[];
}) => {
  return (
    <SearchLandingPageBreadCrumbsContainer>
      <BreadCrumbsBar crumbs={crumbs} />
    </SearchLandingPageBreadCrumbsContainer>
  );
};

export const SearchLandingPageBreadCrumbsWithData: FunctionComponent = () => {
  const cachedQuery = useSearchLandingPageBySlugQuery();

  if (!cachedQuery?.breadCrumbs) return null;

  return (
    <SearchLandingPageBreadCrumbs
      crumbs={cachedQuery.breadCrumbs.map((crumb) => ({
        ...crumb,
        variant: mapApiWeblinkVariantToLinkVariant(crumb.variant),
      }))}
    />
  );
};
